import {
    GET_K_AUDIENCES_SESSIONS_CHARTS_DATA,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
    GET_K_STORE_VISITS_DATA,
    GET_USER_GROWTH_DATA
} from "./actionType";

const initialState = {
    audiencesSessionsData: [],
    storeVisitsData: [],
    error: {},
    userGrowth: {
        timestamps: [],
        totalUsers: [],
        newUsers: [],
        activeUsers: []
    }
};

const KDashboard = (state = initialState, action) => {
    switch (action.type) {
        case API_RESPONSE_SUCCESS:
            if (action.payload.actionType === GET_K_AUDIENCES_SESSIONS_CHARTS_DATA) {
                // Create a deep copy of the data to prevent mutations
                const transformedData = action.payload.data ? 
                    JSON.parse(JSON.stringify(action.payload.data)) : [];
                
                return {
                    ...state,
                    audiencesSessionsData: transformedData
                };
            }
            return state;
        case API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case GET_K_AUDIENCES_SESSIONS_CHARTS_DATA:
                    return {
                        ...state,
                        error: {
                            ...action.payload.error
                        }
                    };
                default:
                    return state;
            }
        case GET_USER_GROWTH_DATA:
            return {
                ...state,
                userGrowth: action.payload
            };
        default:
            return state;
    }
};

export default KDashboard; 